var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u7F16\u8F91") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5207\\u56FE",
    transform: "translate(-255.000000, -1462.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u8F91",
    transform: "translate(255.000000, 1462.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1013737,7.21599829 C14.4156843,7.21599829 14.670473,7.47009799 14.670473,7.78299762 L14.670473,12.909797 C14.670473,13.4305964 14.5052787,13.9282958 14.2056845,14.3118899 C13.859874,14.7556948 13.37128,15 12.8308752,15 L3.26748655,15 C2.73828718,15 2.20349328,14.7682948 1.79958829,14.3643898 C1.38659425,13.9513958 1.15,13.4214909 1.15,12.909797 L1.15,2.96980333 C1.15,2.43430396 1.40549423,1.9275155 1.85139917,1.57960498 C2.25723824,1.26732322 2.75541082,1.09888393 3.26748655,1.10078928 L8.45728587,1.10078928 C8.77140047,1.10078928 9.02604066,1.35544574 9.02604066,1.66956034 C9.02604066,1.98367494 8.77140047,2.23831513 8.45728587,2.23831513 L3.26750296,2.23831513 C2.79429805,2.23831513 2.28749318,2.53231478 2.28749318,2.96911427 L2.28749318,12.9090751 C2.28749318,13.1288858 2.40228758,13.3654801 2.60249281,13.5586798 C2.79849805,13.7490741 3.04698681,13.862474 3.26748655,13.862474 L12.8308752,13.862474 C13.2704802,13.862474 13.5329798,13.37808 13.5329798,12.9097806 L13.5329798,7.78230856 C13.5329798,7.47009799 13.7877686,7.21530923 14.1013737,7.21530923 L14.1013737,7.21599829 Z M7.30228724,8.48859678 C7.0316912,8.21797012 7.0316912,7.77923008 7.30228724,7.50860341 L13.6078743,1.20301636 C13.737518,1.07258507 13.9139783,0.999477003 14.0978792,1.00000282 C14.378159,1.00000282 14.6308337,1.1688651 14.7380901,1.42781082 C14.8453464,1.68675654 14.786064,1.98481404 14.5878841,2.18300973 L8.28159154,8.48859678 C8.15194779,8.61902807 7.97548757,8.69213614 7.79158666,8.69161033 C7.60768575,8.69213614 7.43122552,8.61902807 7.30158177,8.48859678 L7.30228724,8.48859678 Z",
    id: "\\u5F62\\u72B6",
    fill: "#1F70FF",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/编辑.639ca03fccd26d0d93c58fcf6cd7008f.svg";
export { ForwardRef as ReactComponent };